import styles from './loading.module.scss';

export function Loading() {
  return (
    <div className={styles.page}>
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}
